import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsString, ValidateNested } from 'class-validator';
import { IsNotEmptyObjectWithLVS, IsUUIDWithLVS } from '@goparrot/common';
import { PromotionUsageExposeGroup } from '../interface';
import { UsedPromotionDto } from './UsedPromotionDto';
export class CustomCreatePromotionUsageDto {
}
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.CREATE] }),
    IsString({ always: true }),
    ApiProperty({ type: () => String, description: 'Order Id' }),
    __metadata("design:type", String)
], CustomCreatePromotionUsageDto.prototype, "orderId", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.CREATE] }),
    IsUUIDWithLVS('4', { always: true }),
    ApiProperty({ type: () => String, description: 'Order UUID' }),
    __metadata("design:type", String)
], CustomCreatePromotionUsageDto.prototype, "orderUuid", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.CREATE] }),
    Type(() => Date),
    IsDate({ always: true }),
    ApiProperty({ type: () => Date, description: 'Promotion usage date' }),
    __metadata("design:type", Date)
], CustomCreatePromotionUsageDto.prototype, "usedAt", void 0);
__decorate([
    Expose({ groups: [PromotionUsageExposeGroup.CREATE] }),
    Type(() => UsedPromotionDto),
    IsArray({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    ApiProperty({ type: () => UsedPromotionDto }),
    __metadata("design:type", Array)
], CustomCreatePromotionUsageDto.prototype, "promotions", void 0);
//# sourceMappingURL=CustomCreatePromotionUsageDto.js.map